import { Injectable } from '@angular/core';
declare var $: any;
@Injectable({
    providedIn: 'root'
})
export class ClipboardService {
    constructor() {}

    public copyText(text: string, copyHTMLFormatting = false): void {
        let textArea = document.createElement('textarea');

        textArea.style.position = 'fixed';
        textArea.style.left = '0';
        textArea.style.top = '0';
        textArea.style.opacity = '0';
        textArea.value = text;

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        let listener = (e: ClipboardEvent) => {
            let clipboard = e.clipboardData || window['clipboardData'];
            if (copyHTMLFormatting) {
                clipboard.setData('text/plain', text);
                clipboard.setData('text/html', text);
            } else {
                clipboard.setData('text/plain', text);
            }
            e.preventDefault();
        };
        document.addEventListener('copy', listener, false);

        try {
            document.execCommand('copy');
            this.showToast('success', 'Copied to clipboard');
        } catch (err) {
            this.showToast('error', 'Sorry, failed to copy to clipboard');
            console.log(`Error while copying text to clipboard: ${err}`);
        }

        document.removeEventListener('copy', listener, false);

        document.body.removeChild(textArea);
    }

    private showToast(type: 'success' | 'error', message: string) {
        $('body').toast({
            class: type,
            message
        });
    }
}
